import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import "./Assets/WebsiteCss/homepage.css";
import { useEffect, useState } from "react";
import { FaWhatsapp, FaArrowUp } from "react-icons/fa";

import ScrollToTop from "./WebsitePages/ScrollToTop";
import AdminLogin from "./Components/AdminLogin";
import ProtectedRoute from "./Components/ProtectedRoute";
import Dashboard from "./Components/Dashboard";
import Navbar from "./WebsitePages/Navbar";

import Home from "./WebsitePages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import ProjectDetails from "./pages/ProjectDetails";
import Contact from "./pages/Contact";
import { Toaster } from "react-hot-toast";
import Footer from "./WebsitePages/Footer";

import ServicePlanning from "./pages/ServicePlanning";
import ConstructionPlanning from "./pages/ConstructionPlanning";
import InteriorPlanning from "./pages/InteriorPlanning";

// Wrapper component to use useLocation
function AppWrapper() {
  const location = useLocation();
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      setShowScroll(window.scrollY > window.innerHeight / 2);
    };

    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const isAdminRoute =
    location.pathname === "/admin" ||
    location.pathname.startsWith("/dashboard");

  return (
    <>
      {!isAdminRoute && <Navbar />}

      <ScrollToTop />
      <Toaster position="top-right" />
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectDetails />} />
        <Route path="/contact" element={<Contact />} />

        {/* SERVICES ROUTES */}
        <Route path="/services/planning" element={<ServicePlanning />} />
        <Route
          path="/services/construction"
          element={<ConstructionPlanning />}
        />
        <Route path="/services/interior" element={<InteriorPlanning />} />

        {/* ADMIN LOGIN */}
        <Route path="/admin" element={<AdminLogin />} />

        {/* PROTECTED DASHBOARD ROUTES */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
      {!isAdminRoute && <Footer />}
      {/* WHATSAPP - Only show on public pages */}
      {!isAdminRoute && (
        <a
          href="https://api.whatsapp.com/send/?phone=917350135259&text=Hello%2C%20I%20am%20contacting%20from%20your%20RK%20Construction%20website&type=phone_number&app_absent=0"
          className="whatsapp-icon"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp />
        </a>
      )}

      {/* SCROLL TO TOP - Only show on public pages */}
      {!isAdminRoute && showScroll && (
        <button className="scroll-to-top show" onClick={scrollToTop}>
          <FaArrowUp />
        </button>
      )}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
